import { Slot } from "@radix-ui/react-slot";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@repo/blacksmith-ui/cn";

export const CHAT_CARD_SURFACE_CLASS =
  "rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]";
export const CHAT_CARD_CLASS = `${CHAT_CARD_SURFACE_CLASS} px-3 py-3`;
export const CHAT_CARD_INTERACTIVE_CLASS =
  "cursor-pointer transition-colors duration-0 hover:bg-[var(--color-surface-hover)]";
/** Card open in the workspace pane; must follow CHAT_CARD_INTERACTIVE_CLASS in cn() to win the merge. */
export const CHAT_CARD_OPEN_CLASS =
  "bg-[var(--color-surface-hover)] hover:bg-[var(--color-surface-inset-hover)]";

type ChatCardProps = ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
  interactive?: boolean;
};

export function ChatCard({
  asChild,
  interactive,
  className,
  ...props
}: ChatCardProps) {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      data-chat-card
      data-chat-card-interactive={interactive ? true : undefined}
      className={cn(
        CHAT_CARD_CLASS,
        interactive && CHAT_CARD_INTERACTIVE_CLASS,
        className,
      )}
      {...props}
    />
  );
}
